import { buildHeaders } from "./apiConfig";
import { VOICE_PREF_API_URL } from "../constants";

// Internal: POST JSON to the Lambda endpoint
// ─────────────────────────────────────────────────────────────────────────────
const postJSON = async (payload) => {
  if (!VOICE_PREF_API_URL) {
    throw new Error(
      "REACT_APP_VOICE_PREFERENCES_API_URL is not configured. " +
        "Add it to your .env file and restart the dev server."
    );
  }

  const url = VOICE_PREF_API_URL.replace(/\/$/, "");

  let res, json;
  try {
    res = await fetch(url, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(payload),
    });
    json = await res.json().catch(() => ({}));
  } catch {
    throw new Error("NETWORK_ERROR");
  }

  if (!res.ok) {
    if (res.status === 401 || res.status === 403) throw new Error("SESSION_EXPIRED");
    const detail = json.error || json.message || `HTTP ${res.status}`;
    throw new Error(detail);
  }

  return json;
};

export const getVoicePreferences = async (userEmail) => {
  // eslint-disable-next-line no-console
  console.log("[voicePreferencesService] getVoicePreferences →", userEmail);

  const result = await postJSON({
    action: "getVoicePreferences",
    userEmail,
  });

  // result.success = true  → data.pollyMapping has the list
  // result.success = false → treat as not set
  const mapping = result?.data?.pollyMapping || [];

  // eslint-disable-next-line no-console
  console.log(
    `[voicePreferencesService] getVoicePreferences ← ${mapping.length} voice(s) returned`
  );

  return mapping;
};

export const saveVoicePreferences = async (userEmail, pollyMapping) => {
  // eslint-disable-next-line no-console
  console.log(`[voicePreferencesService] saveVoicePreferences → ${pollyMapping.length} voice(s)`, {
    userEmail,
  });

  const result = await postJSON({
    action: "saveVoicePreferences",
    userEmail,
    pollyMapping,
  });

  // eslint-disable-next-line no-console
  console.log("[voicePreferencesService] saveVoicePreferences ← success", result);

  return result;
};
